import { SagaIterator } from '@redux-saga/core';
import { call, put, select } from '@redux-saga/core/effects';
import updateToken from 'utils/updateToken';
import { extractGenFetchData, genFetchedData } from 'redux/fetchedData';
import {
  getAllNotificationForPeriodAPI,
  setAllNotificationIsReadAPI,
  setNotificationIsReadAPI,
} from '../api';
import {
  fetchGetAllNotificationForPeriod,
  fetchSetNotificationIsRead,
  setAllNotificationIsRead,
  setNotificationIsRead,
  setNotificationMessages,
} from '../reducer';
import { NotificationMessages } from '../types';
import { selectorNotificationMessages } from '../selectors'; 
import { saveNotificationsToLS } from '../utils';
 
export function* fetchGetAllNotificationForPeriodWorker({
  payload,
}: ReturnType<typeof fetchGetAllNotificationForPeriod>): SagaIterator<void> {

  const { date } = payload;

  let fetchedData = genFetchedData<NotificationMessages>(null).set(
    'isLoading',
    true,
  );
  yield put(setNotificationMessages(fetchedData));

  try {
    yield call(updateToken);
    const response = yield call(getAllNotificationForPeriodAPI, { date });
    if (response) {
      const merged = saveNotificationsToLS(response);
      fetchedData = fetchedData.set('data', merged);
      yield put(setNotificationMessages(fetchedData));

      // Синхронизация между вкладками
      const channel = new BroadcastChannel('notification_channel');
      channel.postMessage({
        type: 'NOTIFICATIONS_UPDATED',
        payload: merged,
        timestamp: Date.now(),
      });
      channel.close();
    }
  } catch (e) {
    console.error({ e });
  } finally {
    fetchedData = fetchedData.set('isLoading', false);
    yield put(setNotificationMessages(fetchedData));
  }
}
 
export function* fetchSetNotificationIsReadWorker({
  payload,
}: ReturnType<typeof fetchSetNotificationIsRead>): SagaIterator<void> {
  const { notification_id, isRemove } = payload;
  let fetchedData = genFetchedData<boolean>(null).set('isLoading', true);
 
  yield put(setNotificationIsRead(fetchedData));
  try {
    yield call(updateToken);
    const { data: messages } = extractGenFetchData<NotificationMessages>(
      yield select(selectorNotificationMessages),
    );
 
    const response = yield call(setNotificationIsReadAPI, { notification_id });
 
    if (response && messages) {
      let updatedMessages;
      if (isRemove) {
        updatedMessages = messages
          .map((item) =>
            item.notification_id === notification_id
              ? { ...item, is_read: true }
              : item,
          )
          .filter((item) => item.notification_id !== notification_id);
      } else {
        updatedMessages = messages.map((item) =>
          item.notification_id === notification_id
            ? { ...item, is_read: true }
            : item,
        );
      }
 
      if (updatedMessages) {
        const merged = saveNotificationsToLS(updatedMessages);
        const updatedData = genFetchedData<NotificationMessages>(
          merged,
        ).set('data', merged);  

        yield put(setNotificationMessages(updatedData));

        // Синхронизация между вкладками
        const channel = new BroadcastChannel('notification_channel');
        channel.postMessage({
          type: 'NOTIFICATIONS_UPDATED',
          payload: merged,
          timestamp: Date.now(),
        });
        channel.close();
      }
    }
  } catch (e) {
    console.error({ e });
  } finally {
    fetchedData = fetchedData.set('isLoading', false);
    yield put(setNotificationIsRead(fetchedData));
  }
}
 
export function* fetchSetAllNotificationIsReadWorker(): SagaIterator<void> {
  let fetchedData = genFetchedData<boolean>(null).set('isLoading', true);
 
  yield put(setAllNotificationIsRead(fetchedData));
 
  try {
    yield call(updateToken);

    const { data: messages } = extractGenFetchData<NotificationMessages>(
      yield select(selectorNotificationMessages),
    );

    const response = yield call(setAllNotificationIsReadAPI);
 
    if (response && messages) {
      const updatedMessages: NotificationMessages = messages?.map((item) =>
        item.is_read ? item : { ...item, is_read: true },
      );
      if (updatedMessages) {
        const merged = saveNotificationsToLS(updatedMessages);
        const updatedData = genFetchedData<NotificationMessages>(
          merged,
        ).set('data', merged);  

        yield put(setNotificationMessages(updatedData));

        const channel = new BroadcastChannel('notification_channel');
        channel.postMessage({
          type: 'NOTIFICATIONS_UPDATED',
          payload: merged,
          timestamp: Date.now(),
        });
 
        channel.close();
      }
    }
  } catch (e) {
    console.error({ e });
  } finally {
    fetchedData = fetchedData.set('isLoading', false);
    yield put(setAllNotificationIsRead(fetchedData));
  }
}
